{
  "recaptcha_site_key": "6LeUpqwcAAAAAIbPGZBewpl-dRr-Ca7x86v_8Mc0",
  "firebase_api_key": "AIzaSyCiap1CNmRfZ2eNXKMmjEmoYLCc197cUiI",
  "release": "7f0fc8d457b4c93943fec4d93624ad5f46d6f6f7"
}
